import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/ConclusionDetail/Search", params);
};

const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/ConclusionDetail/GetById", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ConclusionDetail/Update?userId=" +
      userData.userId(),
    params
  );
};

const updateItemActive = (id, isActive) => {
  const params = {
    id,
    isActive,
    userId: userData.userId(),
  };

  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/ConclusionDetail/UpdateActive",
    params
  );
};

const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/ConclusionDetail/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

export {
  search,
  getById,
  updateItem,
  updateItemActive,
  deleteItem,
};
